import { Component, OnInit } from '@angular/core';
import { SpinnerService } from 'src/app/services/spinner.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-spinner-overlay-wrapper',
  templateUrl: './spinner-overlay-wrapper.component.html',
  styleUrls: ['./spinner-overlay-wrapper.component.scss']
})
export class SpinnerOverlayWrapperComponent implements OnInit {
  public showSpinner: boolean;
  show$: Observable<boolean>;
  constructor(
    private spinnerService: SpinnerService

  ) { }

  ngOnInit() {
    this.show$ = this.spinnerService.showSpinner;
    // this.spinnerService.showSpinner.subscribe(showSpinnerFlag =>{
    //     this.showSpinner = showSpinnerFlag;
    // });
  }

}
